import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type AcademyConnectionWorkspaceDetailsFragment = { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, icon?: string | null, uri: string };


export type AcademyConnectionWorkspaceDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const AcademyConnectionWorkspaceDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment AcademyConnectionWorkspaceDetails on WorkspaceDetails {
  workspaceId
  workspaceName
  workspaceLogo
  icon
  uri
}
    `;